// our-solutions.jsx (Parent Company Multi-Verticals – Same Design)

import React from 'react';
import './our-solutions.css';

// Parent Company Verticals
const companyVerticals = [
    { id: 1, name: "Digital Lending Stack", icon: "🏦", description: "Complete lending lifecycle infrastructure for all business partners.", delay: 0 },
    { id: 2, name: "Fintech Partnerships", icon: "🤝", description: "Co-lending, channel, and distribution alliances powering growth.", delay: 100 },
    { id: 3, name: "Risk & Underwriting Engine", icon: "📊", description: "AI-driven credit scoring, profiling, and decision automation.", delay: 200 },
    { id: 4, name: "Collections & Recovery Suite", icon: "📞", description: "Digital-first repayment, NACH, e-Mandate & field collections.", delay: 300 },
    { id: 5, name: "Compliance & Regulatory Support", icon: "⚖️", description: "End-to-end RBI-compliant operations & documentation support.", delay: 400 },
];

const DataSegment = ({ data, isLast }) => (
    <div 
        className={`data-segment ${isLast ? 'last-segment' : ''}`}
        data-aos="fade-left"
        data-aos-delay={data.delay}
    >
        <div className="segment-icon-title">
            <span className="segment-icon">{data.icon}</span>
            <h3 className="segment-title">{data.name}</h3>
        </div>
        <p className="segment-description">{data.description}</p>
    </div>
);

const SolutionsSection = () => {
    return (
        <section className="solutions-container">

             <h2 className="display-4 solution-title mb-2">
                    Our Solutions & <span className="solution-secondary-info"> Partner Verticals</span>
                </h2>
                
            <p className="section-subheader" data-aos="fade-up" data-aos-delay="100">
                A unified ecosystem powering multiple fintech and NBFC business verticals.
            </p>

            <div className="data-stream-wrapper">
                {companyVerticals.map((data, index) => (
                    <DataSegment 
                        key={data.id} 
                        data={data} 
                        isLast={index === companyVerticals.length - 1} 
                    />
                ))}
            </div>
        </section>
    );
};

export default SolutionsSection;
